class ValentinePopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  init() {
    this.buttonClose = this.querySelector('.valentine-popup__close');
    const popupId = this.id;
    this.floatingButton = document.querySelector(`[data-popup-id="${popupId}"]`);
  }

  attachEventListeners() {
    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', this.hide.bind(this));
    }

    if (this.floatingButton) {
      this.floatingButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.show();
      });
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }
      return;
    }

    // Re-attach listeners after DOM is ready
    setTimeout(() => {
      this.init();
      this.attachEventListeners();
    }, 100);
  }

  show() {
    super.show();
  }

  hide() {
    super.hide();
  }
}

customElements.define('valentine-popup', ValentinePopup);

// Also handle floating button clicks globally for cases where popup isn't ready
document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.valentine-floating-button__trigger');
  if (trigger) {
    const popupId = trigger.getAttribute('data-popup-id');
    if (popupId) {
      const popup = document.getElementById(popupId);
      if (popup && popup.show) {
        e.preventDefault();
        e.stopPropagation();
        popup.show();
      }
    }
  }
});
